import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CollectionMenu from '../collection_menu';
import {trackEvent, trackTime} from '../../../utils/tracking.js';
import './style.scss';

class Collection extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            showCollections: false,
            clickCameFromComponent: false
        };

        this.toggleCollections = this.toggleCollections.bind(this);
        this.turnOffCollectionsMenu = this.turnOffCollectionsMenu.bind(this);
        this.startTime = Date.now();
    }

    componentDidMount() {
        document.body.addEventListener('mousedown', this.turnOffCollectionsMenu);
        trackTime('collection-component-did-mount', this.startTime, this.props.cardType);
    }

    componentWillUnmount() {
        document.body.removeEventListener('mousedown', this.turnOffCollectionsMenu);
        trackTime('collection-component-will-unmount', this.startTime, this.props.cardType);
    }

    turnOffCollectionsMenu() {
        if (!this.state.showCollections || !(this.collRef && !this.collRef.contains(event.target))) {
            return false;
        }

        this.setState({
            showCollections: false
        });
    }

    toggleCollections(e) {
        e.preventDefault();

        this.setState({
            showCollections: !this.state.showCollections
        });

        trackEvent('collections_list', this.props.cardType, this.props.cardSize);
    }

    render() {
        const { gigId, cardType, icon } = this.props,
            hintClass = cardType === 'list' ? 'hint--bottom-right' : 'hint--top',
            {showCollections} = this.state;

        return (
            <span className="coll-group" ref={(ref) => {this.collRef = ref;}}>
                <a className={`icn-heart-toggle ${hintClass}`}
                    href="#!"
                    data-hint={i18n.t('general.save_in')}
                    data-coll-gig={`coll-gig-${gigId}`}
                    data-gtm-action="hp-clicked-list"
                    data-gtm-event="collections"
                    onClick={(e) => this.toggleCollections(e)}>
                    <i className={icon}></i>
                </a>
                {showCollections && <CollectionMenu {...this.props}/>}
            </span>
        );
    }
}

Collection.propTypes = {
    gigId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    collections: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    cardType: PropTypes.string,
    icon: PropTypes.string,
    saveCollection: PropTypes.func,
    toggleCollection: PropTypes.func
};

export default Collection;



// WEBPACK FOOTER //
// ./src/shared/collect_gig/collection/index.js